export default {
  change: 'change',
  input: 'input',
  updateForm: 'update-form',
  remove: 'remove',
  selectedResult: 'selected-result',
};
